var map = {
	"./address-full.svg": 9853,
	"./address.svg": 365,
	"./agendar.svg": 4515,
	"./card.svg": 9265,
	"./cellphone.svg": 7937,
	"./cupom-full.svg": 369,
	"./cupom-sacola.svg": 101,
	"./cupom.svg": 4081,
	"./delivery.svg": 5171,
	"./drive-thru.svg": 9065,
	"./edit.svg": 7071,
	"./gps.svg": 1053,
	"./help.svg": 9842,
	"./home-full.svg": 6084,
	"./home.svg": 238,
	"./information-full.svg": 307,
	"./information.svg": 9163,
	"./local.svg": 7284,
	"./map.svg": 4167,
	"./pedido-full.svg": 7198,
	"./pedido.svg": 4672,
	"./perfil-full.svg": 3477,
	"./perfil.svg": 7397,
	"./pontos-full.svg": 9486,
	"./pontos.svg": 8512,
	"./promocao-full.svg": 6371,
	"./promocao.svg": 7883,
	"./qrcode.svg": 9129,
	"./retirada.svg": 1431,
	"./sacola-full.svg": 1422,
	"./sacola.svg": 9296,
	"./search.svg": 4999,
	"./success.svg": 8020,
	"./viagem.svg": 3546,
	"./whatsapp.svg": 8945,
	"./work.svg": 5228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9184;